import React from 'react';
import { Title } from '../../Atoms/Title/Title.style';
import { Page, PageContent, Rectangles, Sidebar } from './Contract.style';

import { AlertVariant } from 'uol-host-react-ui/dist/molecules/Alert/Alert.types';
import { Box } from './components/box';
import { AlertContainer } from '../../Molecules/AlertContainer/AlertContainer';

export interface boxes {
    title?: string
    element: React.ReactNode
    collapseHide?: boolean
}
export interface UHCTemplateContractProps {
    boxes?: boxes[],
    sidebar?: React.ReactNode
    status: 'loading' | 'error' | 'ready'
}

const statusToAlertVariant = {
    'loading': 'loader',
    'error': 'danger'
}

const UHCTemplateContract: React.FC<UHCTemplateContractProps> = ({boxes, sidebar, status}: UHCTemplateContractProps) => {
    const isStatusReady = status == 'ready'
    
    return (
        <Page className="container">
            <Title style={{ marginBottom: 8, marginTop: 35 }}>Configurar seu Cloud</Title>
            {!isStatusReady && <AlertContainer
                    variant={statusToAlertVariant[status] as AlertVariant} />
            }     

            {boxes && sidebar && isStatusReady && 
                <PageContent data-testid='template-contract' className="row" >
                    <Rectangles className="col-12 col-md-9">                        
                        {boxes.map((box, index) => 
                            <Box key={index} box={box} index={index}/>                            
                        )}
                    </Rectangles>

                    <Sidebar className="col-12 col-md-3">
                        {sidebar}
                    </Sidebar>                    
                </PageContent>
            }
        </Page>
    );
};

export default UHCTemplateContract;
